import basic from "./templatesCollection/basic";
import remarkable from "./templatesCollection/remarkable";
import tracksmith from "./templatesCollection/tracksmith";
import whereby from "./templatesCollection/whereby";
import treehouse from "./templatesCollection/treehouse";
import times from "./templatesCollection/times";

let templates = [
  ...basic,
  ...remarkable,
  ...tracksmith,
  ...whereby,
  ...treehouse,
  ...times,
];
if (!window.wp) {
  // not inside wp then load dummy template
  templates = [
    {
      id: "dummyTemplate",
      image:
        "https://image.shutterstock.com/image-vector/element-logo-icon-template-design-260nw-1133105243.jpg",
      label: "Black Friday",
      category: "wp-signup-user",
    },
  ];
}

if (!!window.wp) {
  templates = window.wp.hooks.applyFilters(
    "wpmNotificationGravityFormsTemplates",
    templates
  );
}

export default templates;
